import script from "./TeamMemberAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMemberAdd.vue?vue&type=script&setup=true&lang=js"

import "./TeamMemberAdd.vue?vue&type=style&index=0&id=471cc25f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471cc25f"]])

export default __exports__